import comments from './comments';

const root = {
	comments
};

export default root;
